import { ScrollText } from 'lucide-react';
import { LogConsole } from '@speles7172/log-console';
import '@speles7172/log-console/styles.css';
import { logsTransport } from '../api/logs';
import { useInTabbedPage } from '../components/common/TabbedPage';

/**
 * The application's own logs: what the API, the scheduled jobs, the render
 * and video workers and the signed-in browsers wrote, read back out of
 * CloudWatch Logs Insights.
 *
 * The whole screen is `<LogConsole>` from `@speles7172/log-console` —
 * statistics, filters, paging and the record detail come from the package, the
 * same deliberate exception CLAUDE.md records for `AuditLogsPage`: this
 * screen is not built here, so it carries its own stylesheet and labels.
 *
 * The transport is the seam: the console sends a filter, never a query, and
 * `/admin/logs` decides who may read (administrators) and which log groups.
 * It is a tab of the System page, which carries the heading.
 */
export function LogsPage() {
  const embedded = useInTabbedPage();

  return (
    <div className="space-y-6">
      {!embedded && (
        <div className="flex items-center gap-3">
          <ScrollText size={24} />
          <h1 className="text-2xl font-bold">Logs</h1>
        </div>
      )}

      <LogConsole transport={logsTransport} title={null} />
    </div>
  );
}
